import configuration from "@/configuration";
import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
                <Box
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    width={1}
                    flexDirection={{ xs: "column", sm: "row" }}
                >
                    <Box display={"flex"} width={80}>
                        <Box
                            component={"img"}
                            src={`${configuration.assets}content/logo-bimids.png`}
                            height={1}
                            width={1}
                        />
                    </Box>
                    <Box display="flex" flexWrap={"wrap"} alignItems={"center"}>
                        <Box>
                            <Link to="/" target="_blank">
                                <Typography variant={"subtitle2"} color="text.primary">
                                    Website
                                </Typography>
                            </Link>
                        </Box>
                        <Box marginLeft={2}>
                            <Link to="https://server.bim-q.de/" target="_blank">
                                <Typography variant={"subtitle2"} color="text.primary">
                                    BIMQ
                                </Typography>
                            </Link>
                        </Box>
                        <Box marginLeft={2}>
                            <Link to="https://analytics.google.com/" target="_blank">
                                <Typography variant={"subtitle2"} color="text.primary">
                                    Google Analytics
                                </Typography>
                            </Link>
                        </Box>
                    </Box>
                </Box>
            </Grid>

            <Grid size={{ xs: 12 }}>
                <Typography align={"center"} variant={"subtitle2"} color="text.secondary" gutterBottom>
                    &copy; 2023, IDS Platform. All rights reserved.
                </Typography>
            </Grid>
        </Grid>
    );
};

export default Footer;
